import { onMessage } from "firebase/messaging";
import { initFirebase } from "./firebase";

export const setupForegroundNotification = async () => {
    try {
        const { messaging } = await initFirebase();
        
        if (!messaging) return;

        onMessage(messaging, (payload) => {
            // 🔔 1. Play the custom ding sound
            const audio = new Audio("/ding.mp3");
            audio.play().catch((err) => console.warn("Foreground sound blocked:", err));

            // 📩 2. Show the visual notification
            if ("serviceWorker" in navigator) {
                navigator.serviceWorker.ready.then((registration) => {
                    registration.showNotification(payload.data.title, {
                        body: payload.data.body,
                        icon: "/logo1.jpeg"
                    });
                });
            }
        });
    } catch (error) {
        console.error("Foreground notification setup failed:", error);
    }
};